import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

export const PlanesComerciales = {
  planes: [
    {
      nombre_plan: 'Demo',
      precio_plan: 0,
      descripcion_plan: '',
      color_plan: '#c42c46',
      dias_disponible: 1,
      cantidad_de_asistentes: 10,
      carateristicas_plan: [
        {
          nombre: 'Avatares personalizables',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '10',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 5,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre Marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de locales',
          valor: 1,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del exterior de locales',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios del marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de gondolas para exhibir el producto',
          valor: '20 góndolas',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '960',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
      ],
    },
    {
      nombre_plan: 'Ligth',
      precio_plan: 150000,
      descripcion_plan: '',
      color_plan: '#1891c4',
      dias_disponible: 5,
      cantidad_de_asistentes: 150,
      carateristicas_plan: [
        {
          nombre: 'Avatares personalizables',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '150',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: '15',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre Marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de locales',
          valor: 21,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del exterior de locales',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios del marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de gondolas para exhibir el producto',
          valor: 'Desde 20 góndolas por local',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: 'Desde 960 por local.',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
      ],
    },

    {
      nombre_plan: 'Max',
      precio_plan: 280000,
      descripcion_plan: '',
      color_plan: '#3f3f3e',
      dias_disponible: 30,
      cantidad_de_asistentes: 350,
      carateristicas_plan: [
        {
          nombre: 'Avatares personalizables',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '350',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 'Mensual (30)',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre Marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de locales',
          valor: 21,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del exterior de locales',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios del marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de gondolas para exhibir el producto',
          valor: 'Desde 20 góndolas por local',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: 'Desde 960 por local.',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con sistemas ERP',
          valor: 'No',
          color: 'color: red;',
          icon: faCheckCircle,
        },
        {
          nombre: '',
          valor: 'Si',
          color: 'color: white;',
          icon: faCheckCircle,
        },
      ],
    },
    {
      nombre_plan: 'Premium',
      precio_plan: 'Contáctanos',
      descripcion_plan: '',
      color_plan: '#ffa51f',
      dias_disponible: 'Imilitados',
      cantidad_de_asistentes: 1000000,
      carateristicas_plan: [
        {
          nombre: 'Diseño personalizado del mundo',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre:
            'Avatares únicos y personalizados de acuerdo a la experiencia',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: 'ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 'Ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre Marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de locales',
          valor: 'ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del exterior de locales',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios del marketplace',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de gondolas para exhibir el producto',
          valor: 'Desde 20 góndolas por local',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: 'Desde 960 por local.',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con sistemas ERP',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
      ],
    },
  ],
  planesFeria: [
    {
      nombre_plan: 'Demo',
      precio_plan: 0,
      descripcion_plan: '',
      color_plan: '#c42c46',
      dias_disponible: 1,
      cantidad_de_asistentes: 10,
      carateristicas_plan: [
        {
          nombre: 'Avatares personalizables',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '10',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 5,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre Feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 1,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '104',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
      ],
    },
    {
      nombre_plan: 'Ligth',
      precio_plan: 150000,
      descripcion_plan: '',
      color_plan: '#1891c4',
      dias_disponible: 5,
      cantidad_de_asistentes: 150,
      carateristicas_plan: [
        {
          nombre: 'Avatares personalizables',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '150',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: '15',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 2,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '140 por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
      ],
    },

    {
      nombre_plan: 'Max',
      precio_plan: 280000,
      descripcion_plan: '',
      color_plan: '#3f3f3e',
      dias_disponible: 30,
      cantidad_de_asistentes: 350,
      carateristicas_plan: [
        {
          nombre: 'Avatares personalizables',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: 'ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 'Mensual (30)',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 5,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '140 por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con sistemas ERP',
          valor: 'No',
          color: 'color: red;',
          icon: faCheckCircle,
        },
        {
          nombre: '',
          valor: 'Si',
          color: 'color: white;',
          icon: faCheckCircle,
        },
      ],
    },
    {
      nombre_plan: 'Premium',
      precio_plan: 'Contáctanos',
      descripcion_plan: '',
      color_plan: '#ffa51f',
      dias_disponible: 'Imilitados',
      cantidad_de_asistentes: 1000000,

      carateristicas_plan: [
        {
          nombre: 'Diseño personalizado del mundo',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre:
            'Avatares únicos y personalizados de acuerdo a la experiencia',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '350',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 'Ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 'ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '140 por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con sistemas ERP',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
      ],
    },
  ],
  planesFeriaEscolar: [
    {
      nombre_plan: 'Demo',
      precio_plan: 0,
      descripcion_plan: '',
      color_plan: '#c42c46',
      dias_disponible: 1,
      cantidad_de_asistentes: 10,
      carateristicas_plan: [
        {
          nombre: 'Avatares del videojuego Borondo',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '10',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 5,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre Feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 1,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '104',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
      ],
    },
    {
      nombre_plan: 'Ligth',
      precio_plan: 150000,
      descripcion_plan: '',
      color_plan: '#1891c4',
      dias_disponible: 5,
      cantidad_de_asistentes: 150,
      carateristicas_plan: [
        {
          nombre: 'Avatares del videojuego Borondo',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '150',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: '15',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 2,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '140 por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'No',
          color: 'color: red;',
          icon: faTimesCircle,
        },
      ],
    },

    {
      nombre_plan: 'Max',
      precio_plan: 280000,
      descripcion_plan: '',
      color_plan: '#3f3f3e',
      dias_disponible: 30,
      cantidad_de_asistentes: 350,
      carateristicas_plan: [
        {
          nombre: 'Avatares del videojuego Borondo',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: '350',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 'Mensual (30)',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 5,
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '140 por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con sistemas ERP',
          valor: 'No',
          color: 'color: red;',
          icon: faCheckCircle,
        },
        {
          nombre: '',
          valor: 'Si',
          color: 'color: white;',
          icon: faCheckCircle,
        },
      ],
    },
    {
      nombre_plan: 'Premium',
      precio_plan: 'Contáctanos',
      descripcion_plan: '',
      color_plan: '#ffa51f',
      dias_disponible: 'Imilitados',
      cantidad_de_asistentes: 1000000,
      carateristicas_plan: [
        {
          nombre: 'Diseño personalizado del mundo',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre:
            'Avatares únicos y personalizados de acuerdo a la experiencia',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Servicio de almacenamiento en la nube',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para PC',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Disponible para Movil',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Chat Privado',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Registro de visitantes',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de asistentes',
          valor: 'ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Dias disponibles',
          valor: 'Ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de Nombre de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de pabellones',
          valor: 'ilimitados',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización del lobby de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de avisos publicitarios de la feria',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de stands para exhibir el producto',
          valor: '8 stands por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Número de productos',
          valor: '140 por pabellón',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Reportes de actividad',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Personalización de subdominio',
          valor: 'Si',
          color: 'color:#04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con pasarela de pagos',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
        {
          nombre: 'Integración con sistemas ERP',
          valor: 'Si',
          color: 'color: #04c700;',
          icon: faCheckCircle,
        },
      ],
    },
  ],
};
